import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  saleDues: [],
  purchaseDues: [],
  partyDues: [],
};

export const getSaleDues = createAsyncThunk(
  'due-calendar/getSaleDues',
  async ({ consignorIds } = {}) => {
    const { data } = await api.get('/calendar/sale-dues', { consignorIds });

    return data;
  },
);

export const getPurchaseDues = createAsyncThunk(
  'due-calendar/getPurchaseDues',
  async ({ consignorIds } = {}) => {
    const { data } = await api.get('/calendar/purchase-dues', { consignorIds });

    return data;
  },
);

export const getPartyDues = createAsyncThunk(
  'due-calendar/getPartyDues',
  async ({ consignorIds } = {}) => {
    const { data } = await api.get('/calendar/party-dues', { consignorIds });

    return data;
  },
);

const dueCalendar = createSlice({
  name: 'dueCalendar',

  initialState,

  reducers: {
    clearSaleDues: draft => {
      draft.saleDues = initialState.saleDues;
    },
    clearPurchaseDues: draft => {
      draft.purchaseDues = initialState.purchaseDues;
    },
    clearPartyDues: draft => {
      draft.partyDues = initialState.partyDues;
    },
  },

  extraReducers: builder => {
    builder.addCase(getSaleDues.fulfilled, (draft, { payload }) => {
      draft.saleDues = payload;
    });

    builder.addCase(getPurchaseDues.fulfilled, (draft, { payload }) => {
      draft.purchaseDues = payload;
    });

    builder.addCase(getPartyDues.fulfilled, (draft, { payload }) => {
      draft.partyDues = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getSaleDues.rejected,
        getPurchaseDues.rejected,
        getPartyDues.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearSaleDues, clearPurchaseDues, clearPartyDues } =
  dueCalendar.actions;

export default dueCalendar.reducer;
